module.exports = __webpack_public_path__ + "static/img/Arg.0352cb2c.png";